import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";

const MultiNestedSideButton = ({ index, items }) => {
  const location = useLocation();
  const [display, setDisplay] = useState(false);

  const hasMatchingRoute = (subUrls = []) => {
    return subUrls.some((item) => {
      if (item.url && location.pathname.includes(item.url)) return true;
      if (item.subUrl?.length) return hasMatchingRoute(item.subUrl);
      return false;
    });
  };

  useEffect(() => {
    if (hasMatchingRoute(items?.subUrl)) {
      setDisplay(true);
    }
  }, [location.pathname, items?.subUrl]);

  const handleDisplay = () => {
    setDisplay(!display);
  };

  return (
    <>
      <button
        className="w-full py-2.5 hover:bg-[#DB0029]/10 text-sm my-0 flex items-center gap-4 whitespace-nowrap rounded-lg px-4 font-semibold text-slate-700 transition-colors uppercase"
        key={index}
        onClick={handleDisplay}
      >
        <span className="text-2xl">{items.icon}</span>
        <span>{items.title}</span>
        <span className={`ml-auto transition-transform ${display ? 'rotate-180' : ''}`}>
          <FaChevronDown />
        </span>
      </button>

      {display && (
        <ul tabIndex={0} className="text-white uppercase w-full pl-8 pr-4">
          {items?.subUrl?.map((item, idx) =>
            item.subUrl?.length ? (
              <MultiNestedSideButton key={idx} index={idx} items={item} />
            ) : (
              <NavLink
                key={idx}
                to={`/${item.url}`}
                className={({ isActive }) =>
                  isActive
                    ? "w-full py-2.5 mb-2 bg-[#DB0029]/40 shadow shadow-[#DB0029] text-sm my-0 flex items-center gap-4 rounded-lg px-4 font-semibold text-white transition-colors"
                    : "w-full py-2.5 mb-2 hover:bg-[#DB0029]/10 text-sm my-0 flex items-center gap-4 rounded-lg px-4 font-semibold text-slate-700 transition-colors"
                }
              >
                <span className="text-2xl">{item.icon}</span>
                <span>{item.title}</span>
              </NavLink>
            )
          )}
        </ul>
      )}
    </>
  );
};

export default MultiNestedSideButton;







// import React, { useState } from "react";
// import { FaChevronDown } from "react-icons/fa";
// import { NavLink } from "react-router-dom";
// import MultiNestedSideButton from "./MultiNestedSideButton";

// const NestedSideButton = ({ index, items }) => {
//   const [display, setDisplay] = useState(false);
//   const phone = false;
//   const handleDisplay = () => {
//     setDisplay(!display);
//   };

//   return (
//     <>
//       <button
//         className={
//           phone
//             ? ""
//             : "w-full py-2.5 hover:bg-[#DB0029]/10 text-sm my-0 flex items-center gap-4 whitespace-nowrap rounded-lg px-4 font-semibold text-slate-700 transition-colors uppercase"
//         }
//         key={index}
//         onClick={handleDisplay}
//       >
//         <span className="text-2xl">{items.icon}</span>
//         <span>{items.title}</span>
//         <span className="ml-auto">
//           <FaChevronDown />{" "}
//         </span>
//       </button>
//       {display && (
//         <ul tabIndex={0} className="text-white uppercase w-full pl-10 pr-4">
//           {items?.subUrl?.map((item, idx) =>
//             item.subUrl?.length ? (
//               <MultiNestedSideButton key={idx} index={idx} items={item} />
//             ) : (
//               <NavLink
//                 end
//                 key={idx}
//                 to={item.url}
//                 className={({ isActive }) =>
//                   isActive
    
//                     ? "w-full py-2.5 mb-2 bg-[#DB0029]/40 shadow shadow-[#DB0029] text-sm my-0 flex items-center gap-4 rounded-lg px-4 font-semibold text-white transition-colors"
//                     : "w-full py-2.5 mb-2 hover:bg-[#DB0029]/10 text-sm my-0 flex items-center gap-4 rounded-lg px-4 font-semibold text-slate-700 transition-colors"
//                 }
//               >
//                 <span className="text-2xl">{item.icon}</span>
//                 <span>{item.title}</span>
//               </NavLink>
//             )
//           )}
//         </ul>
//       )}
//     </>
//   );
// };

// export default NestedSideButton;
